<template>

  <div class="django-hub">

    <div class="django-hub__head">

      <ButtonPrime

        icon="pi pi-arrow-left"

        class="p-button-text p-button-sm mb-2"

        label="Volver al inicio"

        @click="router.push({ name: 'home' })"

      />

      <p class="django-hub__eyebrow">Panel secundario · Estudyoo</p>

      <h1 class="django-hub__title">Actividades Estudyoo</h1>

      <p class="django-hub__lead">

        Acceso rápido a sync, actividades, asignaciones y juegos. Los datos de cada módulo se cargan solo al entrar.

      </p>

    </div>

    <DjangoAuthGate variant="full" />

    <div class="django-hub__stack">

      <section v-for="section in sections" :key="section.id" class="django-hub__section">

        <h2 class="django-hub__section-title">

          <i :class="`pi pi-${section.icon}`" aria-hidden="true" />

          {{ section.title }}

        </h2>

        <div class="django-hub__grid">

          <button

            v-for="item in section.items"

            :key="item.id"

            type="button"

            :class="['django-hub__tile', item.variant]"

            @click="ir(item.route)"

          >

            <span class="django-hub__tile-icon"><i :class="`pi ${item.icon}`" aria-hidden="true" /></span>

            <span class="django-hub__tile-label">{{ item.label }}</span>

            <span v-if="item.badge" class="django-hub__tile-badge">{{ item.badge }}</span>

            <span class="django-hub__tile-desc">{{ item.description }}</span>

          </button>

        </div>

      </section>

    </div>

  </div>

</template>



<script setup>

import { useRouter } from 'vue-router';
import ButtonPrime from 'primevue/button';
import DjangoAuthGate from '@/components/estudyoo/DjangoAuthGate.vue';

const router = useRouter();



const sections = [

  {

    id: 'sync',

    title: '1 · Sincronización',

    icon: 'cloud-upload',

    items: [

      {

        id: 'sync-django',

        label: 'Sincronizar desde legacy',

        icon: 'pi-sync',

        variant: 'django-hub__tile--teal',

        route: 'sync-django',

        description: 'Por colegio y curso: cursos, capítulos, alumnos. Omite lo que ya está igual.',

      },

      {

        id: 'reporte-inventario',

        label: 'Inventario y conteos',

        icon: 'pi-chart-bar',

        variant: 'django-hub__tile--teal',

        route: 'estudyoo-inventario',

        description: 'Resumen de cursos, alumnos, catálogo y actividades. Carga bajo demanda.',

      },

      {

        id: 'reporte-sync',

        label: 'Reporte por colegio',

        icon: 'pi-table',

        variant: 'django-hub__tile--teal',

        route: 'estudyoo-reporte-sync',

        description: 'Tabla de colegios: cursos, alumnos, asignaturas sync vs catálogo compartido.',

      },

    ],

  },

  {

    id: 'actividades',

    title: '2 · Actividades interactivas',

    icon: 'palette',

    items: [

      {

        id: 'act-mapa',

        label: 'Mapa capítulos y actividades',

        icon: 'pi pi-sitemap',

        variant: 'django-hub__tile--violet',

        route: 'estudyoo-mapa-capitulos',

        description: 'Materia → nivel → curso. Ejes, capítulos y conteos de actividades/asignaciones.',

      },

      {

        id: 'act-asig',

        label: 'Asignar por curso y capítulo',

        icon: 'pi-share-alt',

        variant: 'django-hub__tile--violet',

        route: 'estudyoo-asignaciones',

        description: 'Materia → nivel → curso → capítulo. Publica al catálogo del alumno.',

      },

      {
        id: 'act-manual',
        label: 'Crear actividad manual',
        icon: 'pi pi-file-edit',
        variant: 'django-hub__tile--violet',
        route: 'estudyoo-actividad-manual',
        description: 'Formulario completo: actividad, preguntas, materiales y asignación al curso.',
      },

      {

        id: 'act-mant',

        label: 'Mantenedor actividades',

        icon: 'pi-palette',

        variant: 'django-hub__tile--violet',

        route: 'estudyoo-actividades',

        description: 'Listas bajo demanda: actividades, preguntas y materiales por filtros.',

      },

      {

        id: 'act-ia',

        label: 'Generación con IA',

        icon: 'pi-sparkles',

        variant: 'django-hub__tile--violet',

        route: 'estudyoo-actividades-ia',

        badge: 'IA',

        description: 'Guion de video → actividad por capítulo. Import directo al catálogo.',

      },

    ],

  },

  {

    id: 'juegos',

    title: '3 · Juegos',

    icon: 'star',

    items: [

      {

        id: 'jue-mant',

        label: 'Mantenedor juegos',

        icon: 'pi-star',

        variant: 'django-hub__tile--indigo',

        route: 'estudyoo-juegos',

        description: 'Preguntas por capítulo, alternativas y salas.',

      },

    ],

  },

  {

    id: 'simce',

    title: '4 · SIMCE',

    icon: 'book',

    items: [

      {

        id: 'simce-panel',

        label: 'Panel SIMCE completo',

        icon: 'pi-th-large',

        variant: 'django-hub__tile--slate',

        route: 'simce-admin-dashboard',

        description: 'Gestión, importaciones y banco de ítems SIMCE.',

      },

      {

        id: 'simce-hub',

        label: 'Hub material SIMCE',

        icon: 'pi-book',

        variant: 'django-hub__tile--slate',

        route: 'simce-hub',

        description: 'Acceso rápido al material SIMCE.',

      },

    ],

  },

];



function ir(name) {

  router.push({ name });

}

</script>



<style scoped>

.django-hub {

  max-width: 1080px;

  margin: 0 auto;

  padding: 0 0 2.5rem;

}



.django-hub__head {

  margin-bottom: 1.25rem;

}



.django-hub__eyebrow {

  font-size: 0.72rem;

  font-weight: 700;

  letter-spacing: 0.12em;

  text-transform: uppercase;

  color: #64748b;

  margin: 0 0 0.35rem;

}



.django-hub__title {

  font-size: clamp(1.65rem, 4vw, 2.1rem);

  font-weight: 800;

  letter-spacing: -0.03em;

  color: #0f172a;

  margin: 0 0 0.5rem;

}



.django-hub__lead {

  margin: 0;

  max-width: 42rem;

  font-size: 0.95rem;

  line-height: 1.55;

  color: #64748b;

}



.django-hub__stack {

  display: flex;

  flex-direction: column;

  gap: 1.75rem;

}



.django-hub__section-title {

  display: flex;

  align-items: center;

  gap: 0.5rem;

  font-size: 1rem;

  font-weight: 650;

  color: #1e293b;

  margin: 0 0 0.85rem;

}



.django-hub__section-title .pi {

  color: #2563eb;

  font-size: 1.05rem;

}



.django-hub__grid {

  display: grid;

  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));

  gap: 0.85rem;

}



.django-hub__tile {

  position: relative;

  display: flex;

  flex-direction: column;

  align-items: flex-start;

  gap: 0.45rem;

  padding: 1rem 1.05rem;

  text-align: left;

  border: 1px solid rgba(15, 23, 42, 0.08);

  border-radius: 12px;

  background: linear-gradient(180deg, #fcfcfe 0%, #f4f6f8 100%);

  cursor: pointer;

  font-family: inherit;

  transition: transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease;

}



.django-hub__tile:hover {

  transform: translateY(-3px);

  box-shadow: 0 10px 24px -8px rgba(15, 23, 42, 0.14);

  background: #fff;

  border-color: rgba(15, 23, 42, 0.12);

}



.django-hub__tile:focus-visible {

  outline: 2px solid #2563eb;

  outline-offset: 2px;

}



.django-hub__tile-icon {

  width: 2.4rem;

  height: 2.4rem;

  display: inline-flex;

  align-items: center;

  justify-content: center;

  border-radius: 10px;

  font-size: 1.05rem;

  color: #fff;

}



.django-hub__tile-label {

  font-size: 0.92rem;

  font-weight: 650;

  color: #1e293b;

  line-height: 1.3;

  padding-right: 2.5rem;

}



.django-hub__tile-badge {

  position: absolute;

  top: 0.75rem;

  right: 0.75rem;

  font-size: 0.6rem;

  font-weight: 700;

  letter-spacing: 0.06em;

  text-transform: uppercase;

  padding: 0.15rem 0.4rem;

  border-radius: 4px;

  background: #7c3aed;

  color: #fff;

}



.django-hub__tile-desc {

  font-size: 0.78rem;

  line-height: 1.45;

  color: #64748b;

  font-weight: 400;

}



.django-hub__tile--violet .django-hub__tile-icon {

  background: linear-gradient(140deg, #8b5cf6, #5b21b6);

}

.django-hub__tile--violet {

  border-left: 3px solid #7c3aed;

}



.django-hub__tile--teal .django-hub__tile-icon {

  background: linear-gradient(140deg, #14b8a6, #0f766e);

}

.django-hub__tile--teal {

  border-left: 3px solid #0d9488;

}



.django-hub__tile--indigo .django-hub__tile-icon {

  background: linear-gradient(140deg, #6366f1, #4338ca);

}

.django-hub__tile--indigo {

  border-left: 3px solid #4f46e5;

}



.django-hub__tile--slate .django-hub__tile-icon {

  background: linear-gradient(140deg, #64748b, #334155);

}

.django-hub__tile--slate {

  border-left: 3px solid #475569;

}



@media (max-width: 576px) {

  .django-hub__grid {

    grid-template-columns: 1fr;

  }

  .django-hub__stats {

    grid-template-columns: repeat(2, 1fr);

  }

}

</style>


